import { render } from "./IzinView.vue?vue&type=template&id=642690a8"
import script from "./IzinView.vue?vue&type=script&lang=js"
export * from "./IzinView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__